import { ts } from '_core';

import { validate } from './helpers';
import { DraftParams, INTERACTION_PARAMS } from './types';

export default [
  {
    key: ts.enums.REPORT_ENUMS.WIDGET_KEY_ENUM.BACKTEST_RELATED_ETFS,
    form: true,
    helpLabel: 'vlug25ed3i',
    title: 'Related ETFs',
    neededFiles: ['backtest_related_etfs_detail', 'backtest_related_etfs_performance'],
    interactionParams: Object.values(INTERACTION_PARAMS),
    defaultParams: {} as DraftParams,
    tags: [
      ts.enums.REPORT_ENUMS.REPORT_TAG_ENUM.BACKTEST_DETAILS,
      ts.enums.REPORT_ENUMS.REPORT_TAG_ENUM.BASKET_DETAILS,
    ],
    clearInteractionOnRegenerate: ['table_dtypes'],
    // disableAdd: !config.features.allow_etf,
    validate,
  },
] satisfies ts.types.analysis.WidgetConfig[];
